import { createContext, RefObject } from 'react';

export type AsidesContextValue = {
    ref: RefObject<HTMLElement>,
    aside: {
        [id: string]: {
            open: boolean,
            closeable: boolean
        } | undefined
    },
    closing: string | false,
    toggle: (id: string, open: boolean, closeable: boolean) => void
};

const AsidesContext = createContext<AsidesContextValue>({
    ref: { current: null },
    aside: {},
    closing: false,
    toggle: () => {}
});

AsidesContext.displayName = 'AsidesContext';

export default AsidesContext;
